import { addSideEffects, initAction } from '@poa/state';
import { clone } from '../shared/clone';
import {
  changeColumnPreset,
  deletePreset,
  fetchPayer,
  fetchPayers,
  refreshPayers,
  saveColumnPreset,
  setDates
} from './payers.actions';

const payersAvailablePresets = 'payersAvailablePresets-v1';
const payersLastSelectedPreset = 'payersLastSelectedPreset-v1';


async function fetchPayersFilterRequest(env, {
  filter_by = null,
  page = 1,
  search = null,
  page_size = 25,
  startDate,
  endDate
}) {
  return env.api.payers.fetchPayersFilter(
    filter_by, 
    page, 
    search, 
    page_size, 
    startDate, 
    endDate
    );
}

// fetch
addSideEffects(fetchPayer, async (payload, { actions, env, store }) => {
  try {
    const response = await env.api.payers.fetchPayer(payload.id)
    actions.payerActions.fetchPayerSuccess(response);
  } catch (e) {
    console.error(e);
    actions.payerActions.fetchPayerFailed(e);
    throw e;
  }
});


addSideEffects(fetchPayers, 
  async ({
  filter_by,
  page,
  search,
  page_size,
}, { actions, env, store }) => {
  try {
    const { startDate, endDate } = store.payers.filters;
    const payers = await fetchPayersFilterRequest(env, {
      filter_by: filter_by,
      page: page,
      search: search,
      page_size: page_size,
      startDate: startDate,
      endDate: endDate,
    });
    actions.payersActions.fetchPayersSuccess(payers);
  } catch (e) {
    console.error(e);
    actions.payersActions.fetchPayersFailed();
    throw e;
  }
});

addSideEffects(
  refreshPayers,
  async ({ 
    filter_by,
    page,
    search,
    page_size,
  }, { actions, env, store }) => {
    try {
      const { startDate, endDate } = store.payers.filters;
      const payers = await fetchPayersFilterRequest(env, {
        filter_by: filter_by,
        page: page,
        search: search,
        page_size: page_size,
        startDate: startDate,
        endDate: endDate,
      });

      actions.payersActions.fetchPayersSuccess(payers);
    } catch (e) {
      console.error(e);
      actions.payersActions.fetchPayersFailed();
      throw e;
    }
  }
);


addSideEffects(setDates, async ({ startDate, endDate, shouldFetch = false }, { actions, env }) => {
  if (!shouldFetch) {
    return;
  }

  await env.storage.setItem('payers-dates', clone({ startDate, endDate }));
});


addSideEffects(saveColumnPreset, async (_, { env, actions, store }) => {
  const { availablePresets, currentPresetId } = store.payers.filters.columnSettings;

  await env.storage.setItem(payersAvailablePresets, clone(availablePresets));
  await env.storage.setItem(payersLastSelectedPreset, currentPresetId);
});

addSideEffects(deletePreset, async (_, { env, actions, store }) => {
  const { availablePresets, currentPresetId } = store.payers.filters.columnSettings;

  await env.storage.setItem(payersAvailablePresets, clone(availablePresets));
  await env.storage.setItem(payersLastSelectedPreset, currentPresetId);
});

addSideEffects(changeColumnPreset, async ({ preset }, { env, actions, store }) => {
  const { currentPresetId } = store.payers.filters.columnSettings;

  await env.storage.setItem(payersLastSelectedPreset, currentPresetId);
});

// Restore presets on load
addSideEffects(initAction, async (_, { actions, env, store }) => {
  const availablePresets = await env.storage.getItem(payersAvailablePresets);
  const currentPresetId = await env.storage.getItem(payersLastSelectedPreset);

  if (availablePresets && currentPresetId) {
    actions.payersActions.resetColumnSettings({ presetId: currentPresetId, availablePresets });
    return;
  }

  if (availablePresets) {
    actions.payersActions.resetColumnSettings({
      presetId: availablePresets[0].id, // default one
      availablePresets
    });
    return;
  }

  actions.payersActions.resetColumnSettings({
    presetId: store.payers.filters.columnSettings.availablePresets[0].id, // default one
    availablePresets: store.payers.filters.columnSettings.availablePresets
  });
});
